import React from "react";
import { Box } from "@chakra-ui/react";
import "./styles.css";
import SingleChat from "./SingleChat";
import { ChatState } from "../../context/ChatProvider";
const Chatbox = ({ fetchAgain, setFetchAgain }) => {
  const { selectedChat } = ChatState();
  return (
    <div className={`${selectedChat ? "flex" : "hidden"} md:block w-full`}>
    <SingleChat fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} /></div>
    // <Box
    //   display={{ base: selectedChat ? "flex" : "none", md: "flex" }}
    //   alignItems="center"
    //   flexDir="column"
    //   bg="#D9D9D952"
    //   w={{ base: "100%", md: "53%" }}
    //   borderRadius="lg"
    //   pb="95px"
    //   borderWidth="1px"
    //   className="chatpb"
    //   h="100vh"
    // >
    //   <SingleChat fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
    // </Box>
  );
};

export default Chatbox;
